import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import * as Api from 'api';

export default class RelationshipSelect extends React.Component {
  constructor(props) {
    super(props);
    this.resultsMapper = this.resultsMapper.bind(this);
    this.getOptions = this.getOptions.bind(this);

  }
  resultsMapper(entity) {
    switch(this.props.entity_ref) {
      case 'Client':
      default:
        return {
          value : entity._id,
          label: entity.name
        }
    }
  }
  getOptions(input, callback) {
    switch(this.props.entity_ref) {
      case 'Client':
        return Api
          .findClients(input)
          .then(results => ({ options: results.map(this.resultsMapper) }))
          .catch(error => this.setState({error}));
      default:
        console.warn('<RelationshipSelect />: You must create a valid entity mapping for this relationship.')
        return new Promise((res,rej) => res([]));
    }
  }
  componentWillUnmount() {
    if(this.timer) {
      clearTimeout(this.timer);
    }
  }
  render() {
    const disabled = (this.props.disabled || !this.props.name || !this.props.entity_ref || false);

    return <Select.Async
      name={this.props.name}
      value={this.props.value}
      disabled={disabled}
      loadOptions={this.getOptions}
      onChange={this.props.onChange}
    />
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/form-builder/relationship-select.js